function Contact() {
    return (
      <div className="container py-16">
        <h1 className="text-4xl font-bold mb-8">Contacto</h1>
        <p className="text-lg">Contenido de la página Contacto...</p>
      </div>
    );
  }
  
  export default Contact;